import React from 'react';
import {PropTypes} from 'prop-types';
import {OrderBox} from 'components/fair/fair-order';
import {connect} from 'react-redux';
import {Fairs} from 'base/api';
import ReactPaginate from 'react-paginate';
import {toastr} from 'react-redux-toastr';
import axios from 'axios';
import cookie from 'react-cookie';
import CONFIG from 'base/constants/config';
import { ShowIf } from 'components/utils';
import {UploadImage} from 'components/UI/Image';
import {getPrice} from 'lib/convert';

const ORDER_STATUSES = {
  AWAITING: 0,
  FORWARED: 1,
  CANCELED: 2,
  FINISHED: 3,
};

class OrderList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      orders: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      searchTerm: '',
      categoryId: [],
      API_URL: '',
      access_token: cookie.load('accessToken') || '',
      typeView: 'LIST',
      item: {},
      // orderDetails: [],
      order: {},
      items: {},
      selected: 0,
      orderDetailData: null,
    }

    this.fnCount = 'orders/count';
    this.findStatus = 0;
  }

  componentDidMount() {
    switch (this.props.status) {
      case 'CLOSED':
        this.findStatus = 1;
        break;
      case 'CANCELED':
        this.findStatus = 2;
        break;
      default:
        this.findStatus = 0;
    }

    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          API_URL: response.data.fair.apiUrl
        }, () => {
          this.getData();
        })
      }
    });
  }

  getData () {
    axios.get(`${this.state.API_URL}/${this.fnCount}`,{
      params: {
        where: {
          status: this.findStatus
        }
      },
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.setState({total: response.data.count}, () => {this.loadOrdersFromServer(this.findStatus);})
    }).catch(error => {
      console.log(error)
    })
  }

  loadOrdersFromServer(status) {
    let params = {
      filter: {
        limit: this.props.limit,
        skip: this.state.offset,
        order: 'createdAt DESC',
        include: 'user',
        where: {
          status: status
        }
      }
    }

    axios({
      method: 'GET',
      url:`${this.state.API_URL}/orders`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      params
    }).then(response => {
      let orders = response.data || [];
      let pageCount = Math.ceil(this.state.total / this.props.limit);
      this.setState({
        pageCount,
        orders
      });
    }).catch(error => {
      console.log(error)
    })
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({
      offset: offset,
      selected
    }, () => {
      this.loadOrdersFromServer(this.findStatus);
    });
  };

  confirmDelete(id, reload) {
    if (confirm("Bạn có muốn xóa đơn hàng này không?")) {
      axios({
        method: 'DELETE',
        url:`${this.state.API_URL}/orders/${id}`,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        toastr.removeByType('success');
        toastr.success("", "Đơn hàng đã được xóa");
        this.getData();
      }).catch(error => {
        console.log(error)
      })
    }
  }

  cancel(id, reload) {
    if (confirm("Bạn có muốn hủy đơn hàng này không?")) {
      axios({
        method: 'PATCH',
        url:`${this.state.API_URL}/orders/${id}`,
        headers: {
          Authorization: `${this.state.access_token}`
        },
        data: {
          status: 2
        }
      }).then(response => {
        toastr.removeByType('success');
        toastr.success("", "Đơn hàng đã được hủy");
        this.getData();
      }).catch(error => {
        console.log(error)
      })
    }
  }

  closeOrder(id) {
    if (confirm("Bạn có muốn chuyển tiếp đơn hàng này không?")) {
      axios({
        method: 'POST',
        url:`${this.state.API_URL}/orders/${this.state.order.id}/forward`,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        this.getData();
        this.setState({typeView: 'LIST', orderDetails: [], order: {},})
        toastr.removeByType('success');
        toastr.success("Thành công", "Đơn hàng đã chuyển tiếp");
      }).catch(error => {
        console.log(error)
      })
    }
  }

  goDetail(order) {
    axios({
      method: 'GET',
      url:`${this.state.API_URL}/orders/${order.id}/OrderBusinesses`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      params: {
        filter: {
          include: [
            'business',
            {orderDetails: 'product'}
          ]
        }
      }
    }).then(response => {
      this.parseOrderData(order, response.data || []);
    }).catch(error => {
      console.log(error);
    })
  }

  getBusiness(item, data) {
    axios({
      method: 'GET',
      url:`${this.state.API_URL}/orders/${item.id}/businesses`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.parseOrderData(item, data, response.data)
    }).catch(error => {
      console.log(error)
    })
  }

  /**
   * Parse order data
   * @param {*} order the order instance
   * @param {*} orderBusinesses orderBusinesses of the order
   */
  parseOrderData(order, orderBusinesses) {
    let orderDetailData = orderBusinesses.map(orderBusiness => {
      let products = [];
      if (orderBusiness && orderBusiness.orderDetails) {
        products = orderBusiness.orderDetails.map(orderDetail => ({
          ...orderDetail.product,
          quantity: orderDetail.quantity,
          orderPrice: orderDetail.price,
        }));
      }
      let newOrderBusiness = {
        products,
        business: orderBusiness.business,
        status: orderBusiness.status,
        createdAt: orderBusiness.createdAt,
        updatedAt: orderBusiness.updatedAt,
      };
      return newOrderBusiness;
    });
    this.setState({
      order,
      orderDetailData,
      typeView: 'DETAIL'
    });
  }

  goToList() {
    this.setState({
      orderDetails: [],
      order: {},
      typeView: 'LIST'
    })
  }

  // deprecated
  getPrice(value) {
    String.prototype.splice = function(idx, rem, str) {
      return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
    };
    let result = value;
    if(String(result).length < 3) {
      return result
    } else {
      for (let j = Number(String(result).length); j > 0;) {
        j = j - 3;
        if(j > 0) {
          result = String(result).splice(j, 0, ",");
        }
      }
      return result
    }
  }

  actionPanel(item) {
    return(
      <div className='wrap-btn-actions'>
        <button className="btn btn-action" type="button" onClick={this.confirmDelete.bind(this, item.id)}>Xóa</button>&nbsp;&nbsp;
        <button className="btn btn-action" type="button" onClick={this.goDetail.bind(this, item)}><i className='fa fa-eye' />Chi tiết</button>&nbsp;&nbsp;
        <ShowIf condition={item && item.status === 0}>
          <button className="btn btn-action" type="button" onClick={this.cancel.bind(this, item.id)}>Hủy đơn</button>
        </ShowIf>
      </div>
    )
  }

  render() {
    return (
      <div>
        <ShowIf condition={this.state.typeView === 'LIST'}>
          <table className="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th className="col-lg-4">Người đặt hàng</th>
                <th className="col-lg-2">Ngày đặt</th>
                <th className="col-lg-2">Tổng tiền</th>
                <th className="col-lg-3">Hành động</th>
              </tr>
            </thead>
            {
              this.state.orders.map((order, i) => {
                return (
                  <OrderBox {...order} className='' index={(i + 1 + ((this.state.selected) * this.props.limit))}
                    actionPanel={this.actionPanel(order)}
                  />
                );
              })
            }
            <tfoot>
              <tr>
                <td colSpan='5'>
                  <ReactPaginate previousLabel={"previous"}
                    nextLabel={"next"}
                    breakLabel={<a href="">...</a>}
                    breakClassName={"break-me"}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"} />
                </td>
              </tr>
            </tfoot>

          </table>

        </ShowIf>
        <ShowIf condition={this.state.typeView !== 'LIST'}>
          <div>
            <div className='order-member'>
              <div className='block-title'>
                <p className='title-block normal-size'>Thông tin người mua</p>
              </div>
              <div className='info-member'>
                <p className='name'>{this.state.order.customerName}</p>
                <div className='mamber-info'>
                  <p>{this.state.order.customerAddress ? (this.state.order.customerAddress) : null}</p>
                  <p>Số điện thoại: {this.state.order.customerPhone}</p>
                  <p>
                    Email:
                    <a href={`mailto:${this.state.order.customerEmail}`}>{this.state.order.customerEmail}</a>
                  </p>
                </div>
              </div>
            </div>
            <h3 className='title-section'>Chi tiết đơn hàng</h3>
            { this.state.orderDetailData && this.state.orderDetailData.map(item => (
                <div className='item-order table-responsive'>
                  <p className='name'><strong>Doanh nghiệp:</strong> {item.business && item.business.name}</p>
                  <p><strong>Địa chỉ:</strong> {item.business && item.business.address}</p>
                  <p><strong>Số điện thoại:</strong> {item.business && item.business.phone}</p>
                  <p className="status-text">
                    <strong>Trạng thái: &nbsp;</strong>
                    <ShowIf condition={item.status === ORDER_STATUSES.AWAITING}>
                      <span className="larger label-primary">Đang tiếp nhận</span>
                    </ShowIf>
                    <ShowIf condition={item.status === ORDER_STATUSES.FORWARED}>
                      <span className="larger label-primary">Đang xử lý</span>
                    </ShowIf>
                    <ShowIf condition={item.status === ORDER_STATUSES.FINISHED}>
                      <span className="larger label-success">Đã kết thúc</span>
                    </ShowIf>
                    <ShowIf condition={item.status === ORDER_STATUSES.CANCEL}>
                      <span className="larger label-danger">Đã hủy</span>
                    </ShowIf>
                  </p>
                  <table className="table table-striped col-lg-6" >
                    <thead>
                    <tr>
                      <th className="cell-small text-center">#</th>
                      <th className="cell-large text-center">Hình sản phẩm</th>
                      <th className="cell-large text-center">Thông tin sản phẩm</th>
                      <th className="cell-medium text-right">Đơn giá</th>
                      <th className="cell-normal text-right">Số lượng</th>
                      <th className="cell-medium text-right">Thành tiền</th>
                    </tr>
                    </thead>
                    {item.products.map((product, index) => {
                      let defaultImage = '';
                      if (product && product.images && product.images.length) {
                        defaultImage = product.images[product.images.length -1];
                      }
                      return (
                        <tbody key={product.id}>
                          <tr>
                            <td className="text-center">{index + 1}</td>
                            <td className="text-center wrap-image-table">
                              <UploadImage type="PRODUCT" width="auto" height="auto" image={defaultImage} />
                            </td>
                            <td className="text-center">
                              <span style={{fontWeight: 'bold'}}>{product.name}</span>
                            </td>
                            <td className="text-right">{getPrice(product.orderPrice)}</td>
                            <td className="text-center">{product.quantity}</td>
                            <td className="text-right">{getPrice((product.orderPrice * product.quantity))}</td>
                          </tr>
                        </tbody>
                      );
                    })}
                  </table>
                </div>
              ))}
              <div className='wrap-actions'>
                <ShowIf condition={this.state.order && this.state.order.status === 0}>
                  <button className="btn btn-primary mr15" type="button" onClick={this.closeOrder.bind(this)}>Chuyển tiếp đơn hàng</button>
                </ShowIf>
                <button className="btn btn-primary" type="button" onClick={this.goToList.bind(this)}>Quay lại</button>
              </div>
          </div>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    products: state.fairs.products
  };
}

OrderList.PropTypes = {
  status: PropTypes.oneOf(['PENDING', 'CLOSED', 'CANCELED']),
  limit: PropTypes.number
}

OrderList.defaultProps = {
  status: 'PENDING',
  limit: 20
}

export default connect(mapStateToProps)(OrderList);


// WEBPACK FOOTER //
// ./components/fair/fair-order/OrderList.jsx